// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=js"
// @generated from file warinspace/v2/client_to_server.proto (package warinspace.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BotDifficulty, DebugCommandType, LobbyVisibility, Team, TeamPreference, UpgradePath } from "./common_pb.js";
import { file_warinspace_v2_common } from "./common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file warinspace/v2/client_to_server.proto.
 */
export const file_warinspace_v2_client_to_server: GenFile = /*@__PURE__*/
  fileDesc("CiR3YXJpbnNwYWNlL3YyL2NsaWVudF90b19zZXJ2ZXIucHJvdG8SDXdhcmluc3BhY2UudjIiTwoLQ2xpZW50RnJhbWUSEAoIc2VxdWVuY2UYASABKAQSLgoIbWVzc2FnZXMYAiADKAsyHC53YXJpbnNwYWNlLnYyLkNsaWVudE1lc3NhZ2Ui3g4KDUNsaWVudE1lc3NhZ2USKAoHbW92ZV90bxgBIAEoCzIVLndhcmluc3BhY2UudjIuTW92ZVRvSAASKQoHdXBncmFkZRgCIAEoCzIWLndhcmluc3BhY2UudjIuVXBncmFkZUgAEjIKDHNldF9yb3RhdGlvbhgEIAEoCzIaLndhcmluc3BhY2UudjIuU2V0Um90YXRpb25IABIsCglqb2luX2dhbWUYBSABKAsyFy53YXJpbnNwYWNlLnYyLkpvaW5HYW1lSAASIwoEcGluZxgGIAEoCzITLndhcmluc3BhY2UudjIuUGluZ0gAEjIKDG5hbWVfcmVxdWVzdBgHIAEoCzIaLndhcmluc3BhY2UudjIuTmFtZVJlcXVlc3RIABJEChZ1c2VfYWN0aXZlX2F0X3Bvc2l0aW9uGAggASgLMiIud2FyaW5zcGFjZS52Mi5Vc2VBY3RpdmVBdFBvc2l0aW9uSAASQAoUdXNlX2FjdGl2ZV9vbl9wbGF5ZXIYCSABKAsyIC53YXJpbnNwYWNlLnYyLlVzZUFjdGl2ZU9uUGxheWVySAASNQoOZmlyZV9hdF90YXJnZXQYCiABKAsyGy53YXJpbnNwYWNlLnYyLkZpcmVBdFRhcmdldEgAEiwKCWZpcmVfbWlzcxgLIAEoCzIXLndhcmluc3BhY2UudjIuRmlyZU1pc3NIABIyCgxjaGFuZ2Vfd29ybGQYDSABKAsyGi53YXJpbnNwYWNlLnYyLkNoYW5nZVdvcmxkSAASLgoKc2VuZF9lbW9qaRgPIAEoCzIYLndhcmluc3BhY2UudjIuU2VuZEVtb2ppSAASRAoWbm90X3BsYXlpbmdfbmV4dF9yb3VuZBgcIAEoCzIiLndhcmluc3BhY2UudjIuTm90UGxheWluZ05leHRSb3VuZEgAEicKBGNoYXQYHSABKAsyFy53YXJpbnNwYWNlLnYyLlNlbmRDaGF0SAASMAoLZXZvbHZlX3NoaXAYZCABKAsyGS53YXJpbnNwYWNlLnYyLkV2b2x2ZVNoaXBIABIpCgdzdWljaWRlGGUgASgLMhYud2FyaW5zcGFjZS52Mi5TdWljaWRlSAASMgoMcXVlcnlfd29ybGRzGGYgASgLMhoud2FyaW5zcGFjZS52Mi5RdWVyeVdvcmxkc0gAEjIKDGNyZWF0ZV9sb2JieRhnIAEoCzIaLndhcmluc3BhY2UudjIuQ3JlYXRlTG9iYnlIABIuCgpqb2luX2xvYmJ5GGggASgLMhgud2FyaW5zcGFjZS52Mi5Kb2luTG9iYnlIABIwCgtsZWF2ZV9sb2JieRhpIAEoCzIZLndhcmluc3BhY2UudjIuTGVhdmVMb2JieUgAEjAKC3N0YXJ0X2xvYmJ5GGogASgLMhkud2FyaW5zcGFjZS52Mi5TdGFydExvYmJ5SAASPwoTc2V0X3RlYW1fZGlmZmljdWx0eRhrIAEoCzIgLndhcmluc3BhY2UudjIuU2V0VGVhbURpZmZpY3VsdHlIABI0Cg1xdWVyeV9sb2JiaWVzGGwgASgLMhsud2FyaW5zcGFjZS52Mi5RdWVyeUxvYmJpZXNIABI3Cg90YWtlX2xvYmJ5X3NlYXQYbSABKAsyHC53YXJpbnNwYWNlLnYyLlRha2VMb2JieVNlYXRIABI2Cg5zcGVjdGF0ZV9sb2JieRhuIAEoCzIcLndhcmluc3BhY2UudjIuU3BlY3RhdGVMb2JieUgAEjYKDnN1cnJlbmRlcl92b3RlGG8gASgLMhwud2FyaW5zcGFjZS52Mi5TdXJyZW5kZXJWb3RlSAASQwoVc2V0X2ZlYXR1cmVfb3ZlcnJpZGVzGHAgASgLMiIud2FyaW5zcGFjZS52Mi5TZXRGZWF0dXJlT3ZlcnJpZGVzSAASPQoSY2FuY2VsX2xvYmJ5X3N0YXJ0GHEgASgLMh8ud2FyaW5zcGFjZS52Mi5DYW5jZWxMb2JieVN0YXJ0SAASNAoNZGVidWdfY29tbWFuZBhyIAEoCzIbLndhcmluc3BhY2UudjIuRGVidWdDb21tYW5kSAASOAoPcmVmcmVzaF9hY2NvdW50GHMgASgLMh0ud2FyaW5zcGFjZS52Mi5SZWZyZXNoQWNjb3VudEgAQgkKB3BheWxvYWRKBAgDEARKBAgMEA1KBAgOEA9KBAgQEBFKBAgREBJKBAgSEBNKBAgTEBRKBAgUEBVKBAgVEBZKBAgWEBdKBAgXEBhKBAgYEBlKBAgZEBpKBAgaEBtKBAgbEBxSDmdhbWVfdm94X3Rva2VuUgtsb2dpbl9iZWdpblIMbG9naW5fdmVyaWZ5Ug5yZWdpc3Rlcl9iZWdpblIMcmVnaXN0ZXJfZW5kUgtyZWRlZW1fY29kZVIGbG9nb3V0Ugttb2RfY29tbWFuZFIQcHVyY2hhc2VfcmVjZWlwdFIScHJlcm9sbF9hZF93YXRjaGVkUgtidXlfcHJvZHVjdFINZXF1aXBfcHJvZHVjdCIeCgZNb3ZlVG8SCQoBeBgBIAEoERIJCgF5GAIgASgRIjMKB1VwZ3JhZGUSKAoEcGF0aBgBIAEoDjIaLndhcmluc3BhY2UudjIuVXBncmFkZVBhdGgiNgoKRXZvbHZlU2hpcBIoCgRwYXRoGAEgASgOMhoud2FyaW5zcGFjZS52Mi5VcGdyYWRlUGF0aCIkCgtTZXRSb3RhdGlvbhIVCg1hbmdsZV9yYWRpYW5zGAEgASgCIlAKCEpvaW5HYW1lEjYKD3RlYW1fcHJlZmVyZW5jZRgBIAEoDjIdLndhcmluc3BhY2UudjIuVGVhbVByZWZlcmVuY2USDAoEbmFtZRgCIAEoCSIcCgRQaW5nEhQKDGNsaWVudF9ub25jZRgBIAEoBCIeCgtOYW1lUmVxdWVzdBIPCgduYW1lX2lkGAEgASgNIisKE1VzZUFjdGl2ZUF0UG9zaXRpb24SCQoBeBgBIAEoERIJCgF5GAIgASgRIiYKEVVzZUFjdGl2ZU9uUGxheWVyEhEKCXRhcmdldF9pZBgBIAEoDSI3CgxGaXJlQXRUYXJnZXQSEQoJdGFyZ2V0X2lkGAEgASgNEgkKAXgYAiABKBESCQoBeRgDIAEoESIgCghGaXJlTWlzcxIJCgF4GAEgASgREgkKAXkYAiABKBEiIQoLQ2hhbmdlV29ybGQSEgoKc2VydmVyX251bRgBIAEoDSIJCgdTdWljaWRlIg0KC1F1ZXJ5V29ybGRzIiAKCVNlbmRFbW9qaRITCgtlbW9qaV9pbmRleBgBIAEoDSIVChNOb3RQbGF5aW5nTmV4dFJvdW5kIhgKCFNlbmRDaGF0EgwKBHRleHQYASABKAkiTwoLQ3JlYXRlTG9iYnkSMgoKdmlzaWJpbGl0eRgBIAEoDjIeLndhcmluc3BhY2UudjIuTG9iYnlWaXNpYmlsaXR5EgwKBG5hbWUYAiABKAkiMAoJSm9pbkxvYmJ5EhEKCWpvaW5fY29kZRgBIAEoCRIQCghzcGVjdGF0ZRgCIAEoCCIMCgpMZWF2ZUxvYmJ5IgwKClN0YXJ0TG9iYnkiEgoQQ2FuY2VsTG9iYnlTdGFydCJoChFTZXRUZWFtRGlmZmljdWx0eRIhCgR0ZWFtGAEgASgOMhMud2FyaW5zcGFjZS52Mi5UZWFtEjAKCmRpZmZpY3VsdHkYAiABKA4yHC53YXJpbnNwYWNlLnYyLkJvdERpZmZpY3VsdHkiDgoMUXVlcnlMb2JiaWVzIiAKDVRha2VMb2JieVNlYXQSDwoHc2xvdF9pZBgBIAEoDSIPCg1TcGVjdGF0ZUxvYmJ5Ih4KDVN1cnJlbmRlclZvdGUSDQoFYWdyZWUYASABKAgiTQoMRGVidWdDb21tYW5kEi0KBHR5cGUYASABKA4yHy53YXJpbnNwYWNlLnYyLkRlYnVnQ29tbWFuZFR5cGUSDgoGYW1vdW50GAIgASgFIkwKE1NldEZlYXR1cmVPdmVycmlkZXMSNQoNYWxsX292ZXJyaWRlcxgBIAMoCzIeLndhcmluc3BhY2UudjIuRmVhdHVyZU92ZXJyaWRlIhAKDlJlZnJlc2hBY2NvdW50Ii8KD0ZlYXR1cmVPdmVycmlkZRILCgNrZXkYASABKAkSDwoHZW5hYmxlZBgCIAEoCEIbqgIYV2FySW5TcGFjZS5Qcm90b2NvbC5XaXJlYgZwcm90bzM", [file_warinspace_v2_common]);

/**
 * @generated from message warinspace.v2.ClientFrame
 */
export type ClientFrame = Message<"warinspace.v2.ClientFrame"> & {
  /**
   * @generated from field: uint64 sequence = 1;
   */
  sequence: bigint;

  /**
   * @generated from field: repeated warinspace.v2.ClientMessage messages = 2;
   */
  messages: ClientMessage[];
};

/**
 * Describes the message warinspace.v2.ClientFrame.
 * Use `create(ClientFrameSchema)` to create a new message.
 */
export const ClientFrameSchema: GenMessage<ClientFrame> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 0);

/**
 * @generated from message warinspace.v2.ClientMessage
 */
export type ClientMessage = Message<"warinspace.v2.ClientMessage"> & {
  /**
   * @generated from oneof warinspace.v2.ClientMessage.payload
   */
  payload: {
    /**
     * @generated from field: warinspace.v2.MoveTo move_to = 1;
     */
    value: MoveTo;
    case: "moveTo";
  } | {
    /**
     * @generated from field: warinspace.v2.Upgrade upgrade = 2;
     */
    value: Upgrade;
    case: "upgrade";
  } | {
    /**
     * @generated from field: warinspace.v2.SetRotation set_rotation = 4;
     */
    value: SetRotation;
    case: "setRotation";
  } | {
    /**
     * @generated from field: warinspace.v2.JoinGame join_game = 5;
     */
    value: JoinGame;
    case: "joinGame";
  } | {
    /**
     * @generated from field: warinspace.v2.Ping ping = 6;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: warinspace.v2.NameRequest name_request = 7;
     */
    value: NameRequest;
    case: "nameRequest";
  } | {
    /**
     * @generated from field: warinspace.v2.UseActiveAtPosition use_active_at_position = 8;
     */
    value: UseActiveAtPosition;
    case: "useActiveAtPosition";
  } | {
    /**
     * @generated from field: warinspace.v2.UseActiveOnPlayer use_active_on_player = 9;
     */
    value: UseActiveOnPlayer;
    case: "useActiveOnPlayer";
  } | {
    /**
     * @generated from field: warinspace.v2.FireAtTarget fire_at_target = 10;
     */
    value: FireAtTarget;
    case: "fireAtTarget";
  } | {
    /**
     * @generated from field: warinspace.v2.FireMiss fire_miss = 11;
     */
    value: FireMiss;
    case: "fireMiss";
  } | {
    /**
     * @generated from field: warinspace.v2.ChangeWorld change_world = 13;
     */
    value: ChangeWorld;
    case: "changeWorld";
  } | {
    /**
     * @generated from field: warinspace.v2.SendEmoji send_emoji = 15;
     */
    value: SendEmoji;
    case: "sendEmoji";
  } | {
    /**
     * @generated from field: warinspace.v2.NotPlayingNextRound not_playing_next_round = 28;
     */
    value: NotPlayingNextRound;
    case: "notPlayingNextRound";
  } | {
    /**
     * @generated from field: warinspace.v2.SendChat chat = 29;
     */
    value: SendChat;
    case: "chat";
  } | {
    /**
     * @generated from field: warinspace.v2.EvolveShip evolve_ship = 100;
     */
    value: EvolveShip;
    case: "evolveShip";
  } | {
    /**
     * @generated from field: warinspace.v2.Suicide suicide = 101;
     */
    value: Suicide;
    case: "suicide";
  } | {
    /**
     * @generated from field: warinspace.v2.QueryWorlds query_worlds = 102;
     */
    value: QueryWorlds;
    case: "queryWorlds";
  } | {
    /**
     * @generated from field: warinspace.v2.CreateLobby create_lobby = 103;
     */
    value: CreateLobby;
    case: "createLobby";
  } | {
    /**
     * @generated from field: warinspace.v2.JoinLobby join_lobby = 104;
     */
    value: JoinLobby;
    case: "joinLobby";
  } | {
    /**
     * @generated from field: warinspace.v2.LeaveLobby leave_lobby = 105;
     */
    value: LeaveLobby;
    case: "leaveLobby";
  } | {
    /**
     * @generated from field: warinspace.v2.StartLobby start_lobby = 106;
     */
    value: StartLobby;
    case: "startLobby";
  } | {
    /**
     * @generated from field: warinspace.v2.SetTeamDifficulty set_team_difficulty = 107;
     */
    value: SetTeamDifficulty;
    case: "setTeamDifficulty";
  } | {
    /**
     * @generated from field: warinspace.v2.QueryLobbies query_lobbies = 108;
     */
    value: QueryLobbies;
    case: "queryLobbies";
  } | {
    /**
     * @generated from field: warinspace.v2.TakeLobbySeat take_lobby_seat = 109;
     */
    value: TakeLobbySeat;
    case: "takeLobbySeat";
  } | {
    /**
     * @generated from field: warinspace.v2.SpectateLobby spectate_lobby = 110;
     */
    value: SpectateLobby;
    case: "spectateLobby";
  } | {
    /**
     * @generated from field: warinspace.v2.SurrenderVote surrender_vote = 111;
     */
    value: SurrenderVote;
    case: "surrenderVote";
  } | {
    /**
     * @generated from field: warinspace.v2.SetFeatureOverrides set_feature_overrides = 112;
     */
    value: SetFeatureOverrides;
    case: "setFeatureOverrides";
  } | {
    /**
     * @generated from field: warinspace.v2.CancelLobbyStart cancel_lobby_start = 113;
     */
    value: CancelLobbyStart;
    case: "cancelLobbyStart";
  } | {
    /**
     * @generated from field: warinspace.v2.DebugCommand debug_command = 114;
     */
    value: DebugCommand;
    case: "debugCommand";
  } | {
    /**
     * @generated from field: warinspace.v2.RefreshAccount refresh_account = 115;
     */
    value: RefreshAccount;
    case: "refreshAccount";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message warinspace.v2.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 1);

/**
 * @generated from message warinspace.v2.MoveTo
 */
export type MoveTo = Message<"warinspace.v2.MoveTo"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.MoveTo.
 * Use `create(MoveToSchema)` to create a new message.
 */
export const MoveToSchema: GenMessage<MoveTo> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 2);

/**
 * @generated from message warinspace.v2.Upgrade
 */
export type Upgrade = Message<"warinspace.v2.Upgrade"> & {
  /**
   * @generated from field: warinspace.v2.UpgradePath path = 1;
   */
  path: UpgradePath;
};

/**
 * Describes the message warinspace.v2.Upgrade.
 * Use `create(UpgradeSchema)` to create a new message.
 */
export const UpgradeSchema: GenMessage<Upgrade> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 3);

/**
 * @generated from message warinspace.v2.EvolveShip
 */
export type EvolveShip = Message<"warinspace.v2.EvolveShip"> & {
  /**
   * @generated from field: warinspace.v2.UpgradePath path = 1;
   */
  path: UpgradePath;
};

/**
 * Describes the message warinspace.v2.EvolveShip.
 * Use `create(EvolveShipSchema)` to create a new message.
 */
export const EvolveShipSchema: GenMessage<EvolveShip> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 4);

/**
 * @generated from message warinspace.v2.SetRotation
 */
export type SetRotation = Message<"warinspace.v2.SetRotation"> & {
  /**
   * @generated from field: float angle_radians = 1;
   */
  angleRadians: number;
};

/**
 * Describes the message warinspace.v2.SetRotation.
 * Use `create(SetRotationSchema)` to create a new message.
 */
export const SetRotationSchema: GenMessage<SetRotation> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 5);

/**
 * @generated from message warinspace.v2.JoinGame
 */
export type JoinGame = Message<"warinspace.v2.JoinGame"> & {
  /**
   * @generated from field: warinspace.v2.TeamPreference team_preference = 1;
   */
  teamPreference: TeamPreference;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message warinspace.v2.JoinGame.
 * Use `create(JoinGameSchema)` to create a new message.
 */
export const JoinGameSchema: GenMessage<JoinGame> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 6);

/**
 * @generated from message warinspace.v2.Ping
 */
export type Ping = Message<"warinspace.v2.Ping"> & {
  /**
   * @generated from field: uint64 client_nonce = 1;
   */
  clientNonce: bigint;
};

/**
 * Describes the message warinspace.v2.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 7);

/**
 * @generated from message warinspace.v2.NameRequest
 */
export type NameRequest = Message<"warinspace.v2.NameRequest"> & {
  /**
   * @generated from field: uint32 name_id = 1;
   */
  nameId: number;
};

/**
 * Describes the message warinspace.v2.NameRequest.
 * Use `create(NameRequestSchema)` to create a new message.
 */
export const NameRequestSchema: GenMessage<NameRequest> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 8);

/**
 * @generated from message warinspace.v2.UseActiveAtPosition
 */
export type UseActiveAtPosition = Message<"warinspace.v2.UseActiveAtPosition"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.UseActiveAtPosition.
 * Use `create(UseActiveAtPositionSchema)` to create a new message.
 */
export const UseActiveAtPositionSchema: GenMessage<UseActiveAtPosition> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 9);

/**
 * @generated from message warinspace.v2.UseActiveOnPlayer
 */
export type UseActiveOnPlayer = Message<"warinspace.v2.UseActiveOnPlayer"> & {
  /**
   * @generated from field: uint32 target_id = 1;
   */
  targetId: number;
};

/**
 * Describes the message warinspace.v2.UseActiveOnPlayer.
 * Use `create(UseActiveOnPlayerSchema)` to create a new message.
 */
export const UseActiveOnPlayerSchema: GenMessage<UseActiveOnPlayer> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 10);

/**
 * @generated from message warinspace.v2.FireAtTarget
 */
export type FireAtTarget = Message<"warinspace.v2.FireAtTarget"> & {
  /**
   * @generated from field: uint32 target_id = 1;
   */
  targetId: number;

  /**
   * @generated from field: sint32 x = 2;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 3;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.FireAtTarget.
 * Use `create(FireAtTargetSchema)` to create a new message.
 */
export const FireAtTargetSchema: GenMessage<FireAtTarget> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 11);

/**
 * @generated from message warinspace.v2.FireMiss
 */
export type FireMiss = Message<"warinspace.v2.FireMiss"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.FireMiss.
 * Use `create(FireMissSchema)` to create a new message.
 */
export const FireMissSchema: GenMessage<FireMiss> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 12);

/**
 * @generated from message warinspace.v2.ChangeWorld
 */
export type ChangeWorld = Message<"warinspace.v2.ChangeWorld"> & {
  /**
   * @generated from field: uint32 server_num = 1;
   */
  serverNum: number;
};

/**
 * Describes the message warinspace.v2.ChangeWorld.
 * Use `create(ChangeWorldSchema)` to create a new message.
 */
export const ChangeWorldSchema: GenMessage<ChangeWorld> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 13);

/**
 * @generated from message warinspace.v2.Suicide
 */
export type Suicide = Message<"warinspace.v2.Suicide"> & {
};

/**
 * Describes the message warinspace.v2.Suicide.
 * Use `create(SuicideSchema)` to create a new message.
 */
export const SuicideSchema: GenMessage<Suicide> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 14);

/**
 * @generated from message warinspace.v2.QueryWorlds
 */
export type QueryWorlds = Message<"warinspace.v2.QueryWorlds"> & {
};

/**
 * Describes the message warinspace.v2.QueryWorlds.
 * Use `create(QueryWorldsSchema)` to create a new message.
 */
export const QueryWorldsSchema: GenMessage<QueryWorlds> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 15);

/**
 * @generated from message warinspace.v2.SendEmoji
 */
export type SendEmoji = Message<"warinspace.v2.SendEmoji"> & {
  /**
   * @generated from field: uint32 emoji_index = 1;
   */
  emojiIndex: number;
};

/**
 * Describes the message warinspace.v2.SendEmoji.
 * Use `create(SendEmojiSchema)` to create a new message.
 */
export const SendEmojiSchema: GenMessage<SendEmoji> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 16);

/**
 * @generated from message warinspace.v2.NotPlayingNextRound
 */
export type NotPlayingNextRound = Message<"warinspace.v2.NotPlayingNextRound"> & {
};

/**
 * Describes the message warinspace.v2.NotPlayingNextRound.
 * Use `create(NotPlayingNextRoundSchema)` to create a new message.
 */
export const NotPlayingNextRoundSchema: GenMessage<NotPlayingNextRound> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 17);

/**
 * @generated from message warinspace.v2.SendChat
 */
export type SendChat = Message<"warinspace.v2.SendChat"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message warinspace.v2.SendChat.
 * Use `create(SendChatSchema)` to create a new message.
 */
export const SendChatSchema: GenMessage<SendChat> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 18);

/**
 * @generated from message warinspace.v2.CreateLobby
 */
export type CreateLobby = Message<"warinspace.v2.CreateLobby"> & {
  /**
   * @generated from field: warinspace.v2.LobbyVisibility visibility = 1;
   */
  visibility: LobbyVisibility;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message warinspace.v2.CreateLobby.
 * Use `create(CreateLobbySchema)` to create a new message.
 */
export const CreateLobbySchema: GenMessage<CreateLobby> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 19);

/**
 * @generated from message warinspace.v2.JoinLobby
 */
export type JoinLobby = Message<"warinspace.v2.JoinLobby"> & {
  /**
   * @generated from field: string join_code = 1;
   */
  joinCode: string;

  /**
   * @generated from field: bool spectate = 2;
   */
  spectate: boolean;
};

/**
 * Describes the message warinspace.v2.JoinLobby.
 * Use `create(JoinLobbySchema)` to create a new message.
 */
export const JoinLobbySchema: GenMessage<JoinLobby> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 20);

/**
 * @generated from message warinspace.v2.LeaveLobby
 */
export type LeaveLobby = Message<"warinspace.v2.LeaveLobby"> & {
};

/**
 * Describes the message warinspace.v2.LeaveLobby.
 * Use `create(LeaveLobbySchema)` to create a new message.
 */
export const LeaveLobbySchema: GenMessage<LeaveLobby> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 21);

/**
 * @generated from message warinspace.v2.StartLobby
 */
export type StartLobby = Message<"warinspace.v2.StartLobby"> & {
};

/**
 * Describes the message warinspace.v2.StartLobby.
 * Use `create(StartLobbySchema)` to create a new message.
 */
export const StartLobbySchema: GenMessage<StartLobby> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 22);

/**
 * @generated from message warinspace.v2.CancelLobbyStart
 */
export type CancelLobbyStart = Message<"warinspace.v2.CancelLobbyStart"> & {
};

/**
 * Describes the message warinspace.v2.CancelLobbyStart.
 * Use `create(CancelLobbyStartSchema)` to create a new message.
 */
export const CancelLobbyStartSchema: GenMessage<CancelLobbyStart> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 23);

/**
 * @generated from message warinspace.v2.SetTeamDifficulty
 */
export type SetTeamDifficulty = Message<"warinspace.v2.SetTeamDifficulty"> & {
  /**
   * @generated from field: warinspace.v2.Team team = 1;
   */
  team: Team;

  /**
   * @generated from field: warinspace.v2.BotDifficulty difficulty = 2;
   */
  difficulty: BotDifficulty;
};

/**
 * Describes the message warinspace.v2.SetTeamDifficulty.
 * Use `create(SetTeamDifficultySchema)` to create a new message.
 */
export const SetTeamDifficultySchema: GenMessage<SetTeamDifficulty> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 24);

/**
 * @generated from message warinspace.v2.QueryLobbies
 */
export type QueryLobbies = Message<"warinspace.v2.QueryLobbies"> & {
};

/**
 * Describes the message warinspace.v2.QueryLobbies.
 * Use `create(QueryLobbiesSchema)` to create a new message.
 */
export const QueryLobbiesSchema: GenMessage<QueryLobbies> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 25);

/**
 * @generated from message warinspace.v2.TakeLobbySeat
 */
export type TakeLobbySeat = Message<"warinspace.v2.TakeLobbySeat"> & {
  /**
   * @generated from field: uint32 slot_id = 1;
   */
  slotId: number;
};

/**
 * Describes the message warinspace.v2.TakeLobbySeat.
 * Use `create(TakeLobbySeatSchema)` to create a new message.
 */
export const TakeLobbySeatSchema: GenMessage<TakeLobbySeat> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 26);

/**
 * @generated from message warinspace.v2.SpectateLobby
 */
export type SpectateLobby = Message<"warinspace.v2.SpectateLobby"> & {
};

/**
 * Describes the message warinspace.v2.SpectateLobby.
 * Use `create(SpectateLobbySchema)` to create a new message.
 */
export const SpectateLobbySchema: GenMessage<SpectateLobby> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 27);

/**
 * @generated from message warinspace.v2.SurrenderVote
 */
export type SurrenderVote = Message<"warinspace.v2.SurrenderVote"> & {
  /**
   * @generated from field: bool agree = 1;
   */
  agree: boolean;
};

/**
 * Describes the message warinspace.v2.SurrenderVote.
 * Use `create(SurrenderVoteSchema)` to create a new message.
 */
export const SurrenderVoteSchema: GenMessage<SurrenderVote> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 28);

/**
 * @generated from message warinspace.v2.DebugCommand
 */
export type DebugCommand = Message<"warinspace.v2.DebugCommand"> & {
  /**
   * @generated from field: warinspace.v2.DebugCommandType type = 1;
   */
  type: DebugCommandType;

  /**
   * @generated from field: int32 amount = 2;
   */
  amount: number;
};

/**
 * Describes the message warinspace.v2.DebugCommand.
 * Use `create(DebugCommandSchema)` to create a new message.
 */
export const DebugCommandSchema: GenMessage<DebugCommand> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 29);

/**
 * @generated from message warinspace.v2.SetFeatureOverrides
 */
export type SetFeatureOverrides = Message<"warinspace.v2.SetFeatureOverrides"> & {
  /**
   * @generated from field: repeated warinspace.v2.FeatureOverride all_overrides = 1;
   */
  allOverrides: FeatureOverride[];
};

/**
 * Describes the message warinspace.v2.SetFeatureOverrides.
 * Use `create(SetFeatureOverridesSchema)` to create a new message.
 */
export const SetFeatureOverridesSchema: GenMessage<SetFeatureOverrides> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 30);

/**
 * @generated from message warinspace.v2.RefreshAccount
 */
export type RefreshAccount = Message<"warinspace.v2.RefreshAccount"> & {
};

/**
 * Describes the message warinspace.v2.RefreshAccount.
 * Use `create(RefreshAccountSchema)` to create a new message.
 */
export const RefreshAccountSchema: GenMessage<RefreshAccount> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 31);

/**
 * @generated from message warinspace.v2.FeatureOverride
 */
export type FeatureOverride = Message<"warinspace.v2.FeatureOverride"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message warinspace.v2.FeatureOverride.
 * Use `create(FeatureOverrideSchema)` to create a new message.
 */
export const FeatureOverrideSchema: GenMessage<FeatureOverride> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_client_to_server, 32);

